var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVideoIcon = function SvgVideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.313.5H1.41C.7.5.125 1.102.125 1.813v7.902C.125 10.425.699 11 1.41 11h7.902c.711 0 1.313-.574 1.313-1.285V1.813A1.33 1.33 0 0 0 9.312.5Zm5.167 1.04L11.5 3.616V7.91l2.98 2.078c.575.383 1.395-.027 1.395-.71V2.25c0-.684-.82-1.094-1.395-.71Z",
    fill: "currentColor"
  })));
};
export default SvgVideoIcon;